<template>
  <v-container class="comissions-widget">
    <v-row class="comissions-widget-row">
      <v-col cols="12" class="comissions-widget-col selected">
        <v-subheader>{{ lang.orders.new.commissions.title }}</v-subheader>
        <v-list dense>
          <v-list-item
            v-for="(item, i) in selected"
            :key="i"
            class="selected-list mh-70"
            :class="{ 'deleted': (item.id > 0 && item.delete > 0)}"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-row>
                  <v-col cols="3" class="pa-0 pr-1">
                    <v-autocomplete
                      v-model="item.employee"
                      :items="get_data.employees"
                      :label="lang.orders.new.commissions.form.employee"
                      :rules="lang.orders.new.commissions.form.rules.employee"
                      :no-data-text="lang.scheduler.new.widget.filters.employees.noEmployees"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading || item.delete > 0"
                      item-value="id"
                      item-text="name"
                      :clearable="false"
                      :single-line="false"
                      autocomplete="off"
                      clear-icon="mdi-broom"
                      prepend-inner-icon="mdi-account-tie"
                      class="employees-autocomplete"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="4" class="pa-0 pr-1">
                    <v-autocomplete
                      v-model="item.service"
                      :items="list"
                      :label="lang.orders.new.commissions.form.service"
                      :rules="lang.orders.new.commissions.form.rules.service"
                      :no-data-text="lang.orders.new.commissions.form.noService"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading || item.delete > 0"
                      item-value="id"
                      item-text="title"
                      :clearable="false"
                      :single-line="false"
                      autocomplete="off"
                      clear-icon="mdi-broom"
                      prepend-inner-icon="mdi-star"
                      class="employees-autocomplete"
                      filled
                      hide-details
                      return-object
                    />
                    
                  </v-col>
                  <v-col cols="2" class="pa-0 pr-1">
                    <v-text-field
                      :value="item.percent"
                      @change="$set(item, 'percent', parseInt($event))"
                      :label="lang.orders.new.commissions.form.percent"
                      :rules="lang.orders.new.commissions.form.rules.percent"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading || item.manualprice || item.service === null || item.delete > 0"
                      type="number"
                      suffix="%"
                      filled
                    />
                  </v-col>
                  <v-col cols="3" class="pa-0">
                    <div class="total-select">
                      <v-checkbox
                        v-model="item.manualprice"
                        class="manualprice"
                        :disabled="item.delete > 0"
                        light
                        hide-details
                      ></v-checkbox>
                      <v-currency-field
                        v-model="item.value"
                        :label="lang.orders.new.commissions.form.value"
                        :rules="lang.orders.new.commissions.form.rules.value"
                        :loading="get_interface.loading"
                        :disabled="get_interface.loading || !item.manualprice || item.service === null || item.delete > 0"
                        class="totalprice"
                        filled
                        hide-details
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-tooltip left v-if="item.id > 0 && item.delete > 0">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="restore_(item)"
                    icon small
                    style="margin-top: -28px !important;"
                  >
                    <v-icon>mdi-backup-restore</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.orders.new.payment.actions.restore }}</span>
              </v-tooltip>
              <v-tooltip left v-else>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @dblclick.stop="delete_(item)"
                    icon small
                    style="margin-top: -28px !important;"
                  >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.orders.new.payment.actions.delete }}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click.prevent="new_()"
              color="amber darken-4"
              x-small
              fab
              app
              bottom
              right
            >
              <v-icon small dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.orders.new.commissions.add }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    schedules: {
      type: Array,
      default: () => {
        return []
      }
    },
    services: {
      type: Array,
      default: () => {
        return []
      }
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      selected: [],
      timeOut: null
    }
  },
  computed: {
    list () {
      this.items
      this.services
      let list = []

      if (this.items.length > 0 ) {
        list.push({ header: this.lang.meta.pages.catalog.pages.items.title })
        list = list.concat(this.items)
      }

      if (this.services.length > 0 ) {
        list.push({ header: this.lang.meta.pages.catalog.pages.services.title })
        list = list.concat(this.services)
      }

      return list
    }
  },
  watch: {
    selected: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) {
          var updated = this.update(newVal)
          if (updated) this.$emit('input', [ ...updated ])
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) {
          var updated = this.update(newVal)
          if (updated) this.selected = [ ...updated ]
        }
      }
    },
    schedules: {
      deep: true,
      handler (newVal) {
        let schedules = [ ...newVal ],
            services = [ ...this.services ],
            selected = this.selected || []
        schedules.forEach(sch => {
          if (typeof sch.delete === 'undefined' || sch.delete === 0) {
            let list = sch.list || [],
                employees = (sch.selected || [])
                  .reduce((add, val) => add.concat((val.employees || [])
                    .map(emp => {
                      if (emp !== null) {
                        return (typeof emp === 'object' ? emp.id : emp)
                      }
                    })
                    .filter((emp) => add.indexOf(emp) < 0)), [])
            employees.map(employee => {
              list.map(serv => {
                let service = services.find(serv_ => serv_.UUID === serv) || false
                if (service) {
                  let exist = selected.find(std => std.employee === employee && (std.service || {}).UUID === service.UUID) || false,
                      new_ = {
                        id: 0,
                        employee,
                        service,
                        percent: 10,
                        value: 0,
                        manualprice: false,
                        delete: 0
                      }
                  if (!exist) selected.push({ ...new_ })
                }
              })
            })
          }
        })
      }
    },
    services: {
      deep: true,
      handler () {
        this.selected = this.update([ ...this.selected ])
      }
    },
    items: {
      deep: true,
      handler () {
        this.selected = this.update([ ...this.selected ])
      }
    }
  },
  methods: {
    update (input) {
      let selected = [ ...input ],
          mirror = []
      selected.forEach((val) => {
        let new_ = { ...val }
        if (new_.service !== null && new_.service.total > 0) {
          new_.service = (this.list || []).find(srv => srv.id === new_.service.id)
          let serv_total = (this.get_options.discount_tax_comissions ? parseFloat(new_.service.total - new_.service.taxes) : parseFloat(new_.service.total))
          if (new_.manualprice) {
            // new_.value = (parseFloat(new_.value) > serv_total ? serv_total : parseFloat(new_.value))
            new_.percent = Math.round((parseFloat(new_.value) * 100) / serv_total)
          } else {
            // new_.percent = (new_.percent > 100 ? 100 : new_.percent)
            new_.value = parseFloat((parseInt(new_.percent) / 100) * serv_total).toFixed(2)
          }
        }
        mirror.push({ ...new_ })
      })
      return [ ...mirror ]
    },
    new_ () {
      let selected = this.selected || [],
          blank = {
            id: 0,
            employee: null,
            service: null,
            percent: 10,
            value: 0,
            manualprice: false,
            delete: 0
          }
      selected.push({ ...blank })
    },
    delete_ (val) {
      let selected = this.selected || [],
          index = selected.indexOf(val)
      if (selected[index]) {
        if (val.id > 0) {
          selected[index].delete = 1
          this.$forceUpdate()
        } else {
          selected.splice(index, 1)
        }
      }
    },
    restore_ (val) {
      let selected = this.selected || [],
          index = selected.indexOf(val)
      if (selected[index]) {
        selected[index].delete = 0
        this.$forceUpdate()
      }
    }
  },
  mounted () {
    var updated = this.update(this.value)
    if (updated) this.selected = [ ...updated ]
  }
}
</script>

<style lang="scss" src="./styles/index.scss" />